<span>
    {{ params.value }}
    <app-mazars-information-icon *ngIf="!params?.data?.canBeChanged" class="cursor-pointer" [message]="l('UserGridSetting_Info')" uid="UserGridSetting_Info"></app-mazars-information-icon>
</span>
